import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorDownTrend = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M5 21.75A2.75 2.75 0 0 1 2.25 19V5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v14A2.75 2.75 0 0 1 19 21.75H5ZM3.75 19c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v14Z"
    />
    <path
      fill="#F7A600"
      d="m16.418 13.956-4.26-1.81.408-1.38a.75.75 0 0 0-.388-.886L6.532 7.1a.75.75 0 1 0-.663 1.346l5.08 2.501-.418 1.416a.75.75 0 0 0 .426.902l4.739 2.014-1.728.486c-.407.114-.648.523-.538.913.11.39.53.613.937.498l3.434-.965c.4-.113.641-.51.543-.896l-.841-3.31c-.1-.393-.514-.626-.924-.522-.41.105-.66.508-.561.9l.4 1.573Z"
    />
  </svg>
);
export default SvgTwoColorDownTrend;
